import { createV3Queries } from "@query/utils/createV3Queries";
import { invoicingConfigsApi } from "@api";

export const queriesInvoicingConfigs = createV3Queries(
  "invoicingConfigsApi",
  invoicingConfigsApi
);
